
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../Loader';
import Search from '../Search';
import Table from '../Table';
import { variables } from '../../Tenants';
import Status from '../Status';
import IcoMoon from '../IcoMoon';
import { ICONS } from '../../common/constants';
import Label from '../Label';
import { serviceRequestTableLocalTime } from '../../helpers/validationHelper';
import moment from 'moment';
import { onSaveInboxItem, onFetchInboxServiceRequestList } from '../../store/actions/Inbox';
import InfiniteScroll from 'react-infinite-scroll-component';

const InboxServiceRequestsList = ({
    searchString,
    onSearch,
    onSelectItem
}) => {
    const [hasMoreRecords, setHasMoreRecords] = useState(true);
    const user = useSelector(state => state.auth?.user || {})
    const inboxList = useSelector(state => state.inbox?.inboxList || []);
    const inboxLoader = useSelector(state => state.inbox?.inboxListLoader || false);
    const serviceRequestList = useSelector(state => state.inbox?.inboxServiceRequestsList || []);
    const pageCount = useSelector(state => state.inbox.pageCount);
    const paginationCount = useSelector(state => state.inbox.paginationCount);
    const dispatch = useDispatch();
    const roleName = user.roles[0].role.name;

    /*
    Modified By: Sai Prasad
    Modified Date: 02/09/2022
    Jira Ticket: JUN-3090
    Description: display additional details in message preview 
  */
    const onSelectedItem = async (data) => {
        const params = {
            id: data.id,
            referenceId: data.id,
            referenceType: "Ticket",
            description: data.description,
            // receivedOn: moment().calendar(),
            ticketNumber: data.ticketNumber,
            message: '',
            propertyName: data?.propertyName || "",
            suiteName: data.suiteNumber,
            itemName: data?.itemName || "",
            issueType: data?.issueType || "",
            isNew: true
        };
        if (inboxList && inboxList.length > 0) {
            const inboxObj = inboxList.filter(item => item.referenceId === data.id)[0];
            if (inboxObj && inboxObj.id) {
                onSelectItem({ ...params, id: inboxObj.id });
            } else {
                dispatch(onSaveInboxItem(params))
                onSelectItem(params);
            }
        } else {
            dispatch(onSaveInboxItem(params))
            onSelectItem(params);
        }
    }

    const fetchMoreData = () => {   
        if (paginationCount === pageCount) {
          setHasMoreRecords(false);
        } else {
          dispatch(onFetchInboxServiceRequestList(user.id, roleName, paginationCount+1, searchString, false));
        }
    }

    return (
        <div className='announcementArea'>
            <div id="messagesAreaBg" className='announcementPadding'>
                {inboxLoader && <Loader center={true} />}
                <div className='searchBox'>
                    <Search
                        value={searchString}
                        placeholder={`Search ${variables.serviceRequest}s...`}
                        onChange={onSearch}
                    />
                </div>
                {serviceRequestList && serviceRequestList.length > 0 &&

                <div
                id="scrollableDiv" className='inboxServiceRequestTable'>
                <InfiniteScroll
                dataLength={serviceRequestList.length}
                style={{ display: "flex", flexDirection: "column" }}
                inverse={false}
                hasMore={hasMoreRecords}
                loader={
                  paginationCount === pageCount ||
                  serviceRequestList.length === 0 ? (
                    <div />
                  ) : (
                    <h4>Loading...</h4>
                  )
                }
                scrollableTarget="scrollableDiv"
                next={fetchMoreData}
              >
                <Table
                    columns={[
                        {
                            label: "Ticket #",
                            sortable: true,
                            accessor: "name",
                            cell: (data) => (
                                <div
                                    onClick={() => onSelectedItem(data)} style={{ cursor: 'pointer' }}
                                >
                                    {data.ticketNumber}
                                </div>
                            ),
                        },
                        {
                            label: `${variables.Suite}`,
                            cell: (data) => <div title={data.suiteNumber} className='cut-text'>{data.suiteNumber}</div>
                        },
                        {
                            label: "Description",
                            cell: (data) => <div title={data.description} className='cut-text'>{data.description}</div>,
                        },
                        {
                            label: "Status",
                            cell: (data) => (
                                <Status
                                    icon={<IcoMoon glyph={ICONS[data.status]} />}
                                    label={data.status}
                                />
                            ),
                        },
                        {
                            xsHide: true,
                            label: "Submitted Date",
                            cell: (data) => {
                                const days = moment().diff(
                                    moment(data.createdDate),
                                    "days"
                                );
                                const color = days <= 30 ? "teal" : days <= 60 ? "yellow" : "red";
                                return (
                                    <Label
                                        color={color}
                                        label={serviceRequestTableLocalTime(
                                            data.createdDate
                                        )}
                                    />
                                );
                            },
                        }
                    ]}
                    data={serviceRequestList}
                />
                </InfiniteScroll>
                </div>}
            </div>
        </div>
    )
}


export default InboxServiceRequestsList;